import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Grid,
    LinearProgress,
    Paper,
    Autocomplete,
    TextField,
} from '@mui/material';

import { DetailTool } from '../../shared/components';
import { LayoutBaseDePagina } from '../../shared/layouts';
import { IClientCompany, IUser } from '../../shared/protocolos';
import { VForm, VTextField, useVForm } from '../../shared/forms';
import { ClientCompanyService, UserService } from 'shared/services';

export const UpsertClientCompany = () => {
    const navigate = useNavigate();
    const { id = 'nova' } = useParams<'id'>();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const userId = localStorage.getItem('LOGGED_USER_ID');

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);

    const [users, setUsers] = useState<IUser[]>([]);
    const [selectedUser, setSelectedUser] = useState<IUser | null>(null);

    useEffect(() => {
        UserService.listAllClientCompanyUsers('', 1, 9999, 'name', 'asc').then((result) => {
            if (result instanceof Error) {
                alert(result.message);
            } else {
                setUsers(result.data);
            }
        });
    }, []);

    useEffect(() => {
        if (id !== 'nova') {
            setIsLoadingData(true);
            ClientCompanyService.getById(id).then(result => {
                setIsLoadingData(false);
                if (result instanceof Error) {
                    alert(result.message);
                    navigate('/clientCompany');
                } else {
                    formRef.current?.setData(result);
                    const user = users.find(u => u.id === result.userId);
                    setSelectedUser(user ?? null);
                }
            });
        }
    }, [id, users]);

    useEffect(() => {
        if (selectedUser) {
            formRef.current?.setFieldValue('contactName', selectedUser.name);
            formRef.current?.setFieldValue('contactEmail', selectedUser.email);
            formRef.current?.setFieldValue('contactPhone', selectedUser.telefone);
        }
    }, [selectedUser]);

    const handleSave = (data: any) => {
        console.log("data")
        console.log(data)
        const { name, cnpj, contactName, contactEmail, contactPhone } = data;


        if (!name || !cnpj || !contactName || !contactEmail || !contactPhone) {
            alert('Preencha todos os campos obrigatórios.');
            return;
        }

        if (!selectedUser) {
            alert('Selecione o usuário vinculado à empresa.');
            return;
        }

        setIsLoading(true);

        const payload = {
            name,
            cnpj,
            contactName,
            contactEmail,
            contactPhone,
            userId: selectedUser.id as string,
            createdBy: userId
        };



        const serviceCall = id === 'nova'
            ? ClientCompanyService.create(payload)
            : ClientCompanyService.updateById(id, payload);

        serviceCall.then(result => {
            setIsLoading(false);
            if (result instanceof Error) {
                alert(result.message);
            } else {
                if (isSaveAndClose()) {
                    navigate('/clientCompany');
                } else if (id === 'nova') {
                    navigate(`/clientCompany/detalhe/${result}`);
                }
            }
        });
    };

    return (
        <LayoutBaseDePagina
            barraDeFerramentas={
                <DetailTool
                    textoBotaoNovo={id !== 'nova' ? 'Nova' : undefined}
                    mostrarBotaoSalvarEFechar
                    mostrarBotaoNovo={id !== 'nova'}
                    mostrarBotaoApagar={id !== 'nova'}
                    aoClicarEmApagar={() => {
                        if (window.confirm('Deseja realmente apagar?')) {
                            ClientCompanyService.deleteById(id, userId as string).then(result => {
                                if (result instanceof Error) {
                                    alert(result.message);
                                } else {
                                    navigate('/clientCompany');
                                }
                            });
                        }
                    }}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => navigate('/clientCompany')}
                    aoClicarEmNovo={() => navigate('/clientCompany/detalhe/nova')}
                />
            }
        >
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} component={Paper} variant="outlined" padding={2}>
                    {(isLoading || isLoadingData) && <LinearProgress />}

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <VTextField fullWidth label="Nome" name="name" />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <VTextField fullWidth label="CNPJ" name="cnpj" />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Autocomplete
                                options={users}
                                getOptionLabel={(option) => option.name}
                                value={selectedUser}
                                onChange={(_, newValue) => setSelectedUser(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Usuário vinculado" />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <VTextField fullWidth label="Nome do responsável" name="contactName" disabled />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <VTextField fullWidth label="Email do responsável" name="contactEmail" disabled />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <VTextField fullWidth label="Telefone do responsável" name="contactPhone" disabled />
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina>
    );
};